import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResetUserMfaVerifiersPermittedParams {
  userIds: string[];
}

export interface IResetUserMfaVerifiersPermittedResult extends IResult {
  permitted: boolean;
}


export class ResetUserMfaVerifiersPermitted extends Request<IResetUserMfaVerifiersPermittedParams, IResetUserMfaVerifiersPermittedResult> {
  constructor(userIds: string[]) {
    super('resetMFAVerifiersPermitted', {userIds});
  }
}
